import React from 'react';
import { useCurrentUser } from '../contexts/CurrentUserContext';
import aideyLogo from '../assets/sidebar-logo.svg';

// CASCADE-2 — a covered ADULT (business seat or household member) whose account
// owner has lapsed. The member is NOT the person who can fix it: no payment action,
// no card link. Name the owner if we have it.
const NAVY = '#0C2D48';

export default function CoveredMemberPaused({ ownerName }) {
  const { logout } = useCurrentUser();
  const who = ownerName ? ownerName : 'the account owner';
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 'var(--z-modal)',
      background: `linear-gradient(150deg, ${NAVY} 0%, #1a4a7a 50%, #0a2038 100%)`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '1.5rem', fontFamily: 'Raleway, sans-serif',
    }}>
      <div style={{
        background: '#fff', borderRadius: 18, padding: '2.5rem 2rem',
        maxWidth: 460, width: '100%', textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.35)',
      }}>
        <img src={aideyLogo} alt="Aidey" style={{ height: 40, margin: '0 auto 1.5rem', display: 'block' }} />
        <div style={{ fontSize: '2.5rem', marginBottom: '0.75rem' }}>⏸️</div>
        <h2 style={{ fontFamily: 'Poppins, sans-serif', fontSize: '1.3rem', fontWeight: 800, color: NAVY, margin: '0 0 0.65rem' }}>
          Aidey is paused for this account
        </h2>
        <p style={{ color: '#555', fontSize: '0.95rem', lineHeight: 1.6, margin: '0 0 1.5rem' }}>
          {who === 'the account owner'
            ? 'The account owner’s subscription has lapsed, so Aidey is paused for everyone on this account.'
            : <>{who}’s subscription has lapsed, so Aidey is paused for everyone on this account.</>}
          {' '}Please ask {who} to update the billing to bring everyone back. There is nothing you need to do, and no payment is needed from you.
        </p>
        <button
          onClick={() => logout()}
          style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: '#bbb', fontSize: '0.8rem', textDecoration: 'underline', fontFamily: 'Raleway, sans-serif',
          }}
        >
          Log out
        </button>
      </div>
    </div>
  );
}
